var _linearGradient, _path, _radialGradient, _path2, _linearGradient2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Briefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5dniRY~PPjSqIO9PSW_ia",
    x1: 24,
    x2: 24,
    y1: 8.979,
    y2: 6.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b33f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#c74724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#d94f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#e4532b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#e8552c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g5dniRY~PPjSqIO9PSW_ia)",
    d: "M28.5,6h-9C18.672,6,18,6.672,18,7.5V9h12V7.5C30,6.672,29.328,6,28.5,6z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5dniRY~PPjSqIO9PSW_ib",
    cx: 23.832,
    cy: 5.992,
    r: 45.74,
    gradientTransform: "matrix(1 0 0 .8044 0 1.172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40150b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#622110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#953218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#ba3f1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#d14722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#d94a23"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g5dniRY~PPjSqIO9PSW_ib)",
    d: "M42,41H6c-1.1,0-2-0.9-2-2V13c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v26C44,40.1,43.1,41,42,41z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5dniRY~PPjSqIO9PSW_ic",
    x1: 24,
    x2: 24,
    y1: 9.028,
    y2: 26.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc7d5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f8734f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f3653d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#f05b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#ee552a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed5328"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g5dniRY~PPjSqIO9PSW_ic)",
    d: "M42.297,25.255L24,28L5.703,25.255C4.724,25.109,4,24.268,4,23.278V13c0-2.2,1.8-4,4-4h32 c2.2,0,4,1.8,4,4v10.278C44,24.268,43.276,25.109,42.297,25.255z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6eca5",
    d: "M25.5,21h-3c-0.276,0-0.5,0.224-0.5,0.5v3c0,0.276,0.224,0.5,0.5,0.5h3c0.276,0,0.5-0.224,0.5-0.5v-3 C26,21.224,25.776,21,25.5,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Briefcase);
export default __webpack_public_path__ + "static/media/icons8-briefcase.01fb211964ce985e2f3965843b4b4998.svg";
export { ForwardRef as ReactComponent };